import Axios from 'axios';

export default {
  actions: {
    async fetchBots(ctx) {
      try {
        const result = await Axios.get(Axios.defaults.route + '/bots');
        if (result.data) ctx.commit('UPDATE_BOT_LIST', result.data);
      } catch (e) {
        console.error("fetchBots finished with error:", e.message);
      }
    },
    async fetchBot(ctx, id) {
      try {
        const result = await Axios.get(Axios.defaults.route + '/bot/' + id);
        if (result.data) ctx.commit('UPDATE_BOT', result.data);
      } catch (e) {
        console.error("fetchBot finished with error:", e.message);
      }
    },
    async saveBotAction(ctx, data) {
      try {
        data.botData = this.getters.botData;
        console.log("saveBotAction", data);
        const result = await Axios.patch(Axios.defaults.route + '/bot/' + data.id, data);
      } catch (e) {
        console.error("saveBotAction finished with error:", e.message);
      }
    },
    async createBot(ctx, data) {
      try {
        const result = await Axios.post(Axios.defaults.route + '/bot', data);
        return result.data.id;
      } catch (e) {
        console.error("createBot finished with error:", e.message);
      }
    },
    async deleteBot(ctx, id) {
      try {
        const { data } = await Axios.delete(Axios.defaults.route + '/bot/' + id);
        return data
      } catch (e) {
        console.error("deleteBot finished with error: ", e.message);
      }
    },
    async updateBotCompany(ctx, data) {
      try {
        const result = await Axios.patch(Axios.defaults.route + '/bot/company/' + data.botId, {companyId: data.companyId});
      } catch (e) {
        console.error("deleteBot finished with error: ", e.message);
      }
    }
  },
  mutations: {
    UPDATE_BOT_LIST(state, bots) {
      state.bots = bots
    },
    UPDATE_BOT(state, bot) {
      state.bot = bot;
    },
    UPDATE_BOT_NAME(state, name) {
      state.bot.bot_name = name
    },
    UPDATE_BOT_DATA(state, data) {
      state.bot.botData = data
    },
    REMOVE_BOT_FROM_BOT_LIST(state, id) {
      const index = state.bots.findIndex(bot => bot.id === id);
      if (index !== -1) {
        state.bots.splice(index, 1)
      } 
    },
    UPDATE_BOT_COMPANY(state, data) {
      const index = state.bots.findIndex(bot => bot.id === data.id);
      if (index !== -1) {
        state.bots[index].companyId = data.companyId;
      } 
    } 
  },
  state: {
    bots: [],
    bot: {}
  },
  getters: {
    allBots(state) {
      return state.bots;
    },
    botsCount(state) {
      return state.bots.length;
    },
    bot(state) {
      return state.bot;
    },
    botData(state) {
      return state.bot.botData;
    }
  }
}